// extracted by mini-css-extract-plugin
module.exports = {"BuildControl":"BuildControl_BuildControl__3QgrK","Label":"BuildControl_Label__2yr_C","Less":"BuildControl_Less__7lV7c","More":"BuildControl_More__1JvC4"};